// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1--K1","footer":"ModalUpdate_footer__3opDE"};